export default __webpack_public_path__ + "en-CA.123213b3.csv";